module.exports = __webpack_public_path__ + "static/img/zengzhi.b5e38c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zengzhi.png
// module id = QwJC
// module chunks = 1